import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    businessReviewModal: {
      height: '100%',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'stretch',
      padding: '0 40px 88px 40px',

      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        padding: '0 10px 40px 10px',
      },

      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        padding: '0 0 40px 0',
      },
    },
    left: {
      maxWidth: '660px',
      justifyContent: 'space-between',
      gap: '40px',

      [theme.breakpoints.down('md')]: {
        height: '100%',
      },
    },
    content: {
      gap: '40px',
    },
    title: {
      fontSize: '80px',
      color: theme.colors.black,
      lineHeight: '100%',
    },
    date: {},
    description: {
      maxWidth: '574px',
      fontSize: '24px',
    },
    bottom: {
      gap: '40px',
      paddingBottom: '20px',
    },
    buttonContent: {
      display: 'flex',
      gap: '16px',
      alignItems: 'center',
      justifyContent: 'flex-end',
      fontSize: '22px',
    },
    arrow: {
      width: '32px',
      height: '18px',
      marginTop: '4px',
    },
    image: {
      maxWidth: '464px',
      width: '100%',
      alignSelf: 'flex-end',
    },
  }),
  { name: 'BusinessReviewModal' },
);

export default useStyles;

export const modalStyle = {
  container: {
    // padding: '18px 60px 60px 60px',
    // height: '100%',
  },
  modal: {
    height: '100%',
  },
  content: {
    // display: 'flex',
    // alignItems: 'stretch',
    padding: '18px 20px 0 20px',
    height: 'calc(100% - 42px)',
  },
  contentInner: {
    height: '100%',
    maxHeight: '758px',
    overflowY: 'auto',
    // padding: '18px 60px 0 60px',
    // height: 'calc(100% - 42px)',
  },
  header: {
    // background: COLORS.WHITE,
    padding: '12px 20px',
    height: '42px',
    // position: 'sticky',
    top: 0,
  },
};

export const modalInputStyle = {
  display: 'flex',
  borderRadius: '24px',
  maxWidth: '1340px',
  width: '100%',
  maxHeight: '810px',
  height: '100%',
};

export const buttonStyle = {
  button: {
    height: '56px',
    border: '1px solid transparent',
  },
};
